import React from "react"
import "./styles.css"
import { green500, blue500, grey500, red500 } from "material-ui/styles/colors"
import { CircularProgress } from "material-ui"
import * as api from "../../../api"
import ToolTip from "react-portal-tooltip"
import strings from "../../../localization/strings"
import { IJobInfo } from "../../../models"

interface IProps {
	event: { 
		start: Date, 
		end: Date, 
		jobName: string, 
		jobId: string, 
		elId: number,
		jobInfo: IJobInfo,
		status: blue500 | grey500 | green500 | red500 // (Blue | Grey | Green | Red) (Requested | Available | Confirmed Work | Others)
		distanceToJob: string
		setJobInfo(jobInfo: IJobInfo): void,
		previouslyFetchedJobId: string,
		setPreviouslyFetchedJobId(previouslyFetchedJobId: string): void,
	}
}

interface IState {
	open: boolean,
	jobInfo: IJobInfo
	loading: boolean
}

export default class MonthEvent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false,
			jobInfo: undefined,
			loading: false,
		}
	}

	getJobInfo(jobId: string) {
		if (this.props.event.previouslyFetchedJobId === undefined || (this.props.event.previouslyFetchedJobId && this.props.event.previouslyFetchedJobId !== jobId)) {
			this.setState({ loading: true }, () => {
				this.props.event.setPreviouslyFetchedJobId(jobId)
				api.getJobInfo(jobId).then(res => {
					this.props.event.setJobInfo(res.data)
					this.setState({ loading: false, jobInfo: res.data })
				})
			})
		}
		else {
			this.setState({ jobInfo: this.props.event.jobInfo })
		}
    }

	render() {
		return (
			<div
				id={`job-${this.props.event.elId}`}
				className="Job-Event"
				style={{ background: this.props.event.status }}
				onMouseEnter={() => {
					this.getJobInfo(this.props.event.jobId)
					this.setState({ open: true })
				}}
				onMouseLeave={() => this.setState({ open: false })}
			>
				<div className="Job-EventTime TextOverflow">
					{this.props.event.jobName}
				</div>
				<div
					className="Job-EventName TextOverflow"
				>
					{this.props.event.distanceToJob}
				</div>
				<ToolTip active={this.state.open} position="top" arrow="center" parent={`#job-${this.props.event.elId}`}>
					<div>
						{this.state.loading ? (
							<CircularProgress style={{ padding: 0 }} size={22} />
						) : (
							<div style={{ padding: 3 }}>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Job_Name}: </strong>{this.state.jobInfo && this.state.jobInfo.JobName}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Client_Name}: </strong>{this.state.jobInfo && this.state.jobInfo.ClientName}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Occupations}: </strong>{this.state.jobInfo && this.state.jobInfo.OccupationNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Specialties}: </strong>{this.state.jobInfo && this.state.jobInfo.SpecialtyNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Badges}: </strong>{this.state.jobInfo && this.state.jobInfo.BadgeNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Status}: </strong>{this.state.jobInfo && this.state.jobInfo.Status}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Employee}: </strong>{this.state.jobInfo && this.state.jobInfo.EmployeeNames}</p>
								{this.props.event.distanceToJob !== "" &&
									<p style={{ padding: 0, margin: 0 }}><strong>{strings.Distance_To_Job}: </strong>{this.props.event.distanceToJob}</p>
								}
							</div>
						)}
					</div>
				</ToolTip>
			</div>
		)
	}
}